import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const {
  FiGlobe,
  FiMail,
  FiMusic,
  FiShoppingBag
} = FiIcons;

const {
  FaAmazon,
  FaApple,
  FaInstagram,
  FaSpotify,
  FaTiktok,
  FaYoutube
} = FaIcons;

const BRANDS = {
  youtube: {
    icon: FaYoutube,
    colors: ['#FF0000', '#FF4D6D', '#A78BFA']
  },
  tiktok: {
    icon: FaTiktok,
    colors: ['#25F4EE', '#FF0050']
  },
  instagram: {
    icon: FaInstagram,
    colors: ['#E4405F', '#C13584']
  },
  spotify: {
    icon: FaSpotify,
    colors: ['#1DB954', '#1ED760']
  },
  apple_music: {
    icon: FaApple,
    colors: ['#FA243C', '#FB5C75']
  },
  amazon_music: {
    icon: FaAmazon,
    colors: ['#FF9900', '#FFB347']
  },
  amazon: {
    icon: FaAmazon,
    colors: ['#FF9900', '#FFB347']
  }
};

export default function SocialIcon({
  platform,
  variant = 0,
  className = ''
}) {
  if (platform === 'email') {
    return (
      <SafeIcon
        icon={FiMail}
        className={className}
        style={{ color: variant > 0 ? '#67E8F9' : '#22D3EE' }}
      />
    );
  }

  if (platform === 'website') {
    return (
      <SafeIcon
        icon={FiGlobe}
        className={className}
        style={{ color: variant > 0 ? '#34D399' : '#10B981' }}
      />
    );
  }

  const brand = BRANDS[platform];

  if (brand) {
    const color = brand.colors[variant % brand.colors.length];

    return (
      <SafeIcon
        icon={brand.icon}
        className={className}
        style={{ color }}
      />
    );
  }

  if (platform === 'shop') {
    return (
      <SafeIcon
        icon={FiShoppingBag}
        className={className}
        style={{ color: '#64E8CE' }}
      />
    );
  }

  return (
    <SafeIcon
      icon={FiMusic}
      className={className}
      style={{ color: '#A78BFA' }}
    />
  );
}